import { CommonModule, } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewEncapsulation, NgModule, Output, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { PortalObjectsService } from '../../_services/portal-objects.service';
import { PortalProjectObject } from '../../_models/project_portal_objects';
import { Companies } from '../../_models/admin';
import { PortalAdminService } from '../../_services/portal-admin.service';
import { Users } from '../../_models/admin';
import { CompaniesComponent } from '../admin/companies/companies.component';
import { Projects, emptyProjects } from '../../_models/admin';
import { UsersComponent } from '../admin/users/users.component';
import { ProjectsComponent } from '../admin/projects/projects.component';
import { ObjectsComponent } from '../admin/objects/objects.component';
import { AccessComponent } from '../admin/access/access.component';
import {
  Subject,
  Subscription
} from 'rxjs';
import { PortalLogComponent } from './portallog/portal-log/portal-log.component';
import {
  KENDO_NOTIFICATION,
  NotificationService,
} from "@progress/kendo-angular-notification";
import { HeaderService } from '../../_services/header.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ImportdataComponent } from './importdata/importdata.component';

@Component({
    selector: 'app-admin',
    imports: [RouterOutlet, KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION,
        LayoutModule, CommonModule, DropDownListModule, CompaniesComponent, LabelModule, UsersComponent, ProjectsComponent, ObjectsComponent, AccessComponent, PortalLogComponent, ReactiveFormsModule,ImportdataComponent],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminComponent implements OnInit {
  latestUploads: any[] = [];
  selection: any[] = [];
  tmp1: any[] = [];
  projects: PortalProjectObject[] = [];
  filteredProjects: PortalProjectObject[] = [];
  portalObjects: PortalProjectObject[] = [];
  adminCompanies: Companies[] = [];
  loginUser!: Users;
  isAdmin: boolean = false;
  onDestroy$: Subject<void> = new Subject();
  objectsLoading: boolean = false;
  companiesLoading: boolean = false;
  portalObjectService = inject(PortalObjectsService);
  portalAdminService = inject(PortalAdminService);
  projectdisabled: boolean = false;
  @Output() selprojectid!: number;
  projectSelected: any;
  selectedproject!: Projects;
  projectControl = new FormControl(null);

  private subscription: Subscription;

  constructor(private cdr: ChangeDetectorRef, private notificationService: NotificationService, private service: HeaderService) {
    module: bolean: true;
    this.subscription = new Subscription();
  }

  
  defaultItem = emptyProjects();
  ngOnInit(): void {
    this.subscription = this.service.data$.subscribe(data => {
      this.loginUser = data;
      this.cdr.markForCheck();
    });

    // this.userType = sessionStorage.getItem('userType') ?? '';
    /*this.portalAdminService.getLoginUsers().subscribe({
      next: (result) => {
        this.loginUser = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.showError(JSON.stringify(error.message));
      },
      complete: () => {
*/


    this.getProjectList();
    
    //}
    //});
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // Prevent memory leaks
  }

  getProjectList(){
    if (this.loginUser.usertype === 'A') {

      this.isAdmin = true;

      this.portalObjectService.getProjects().subscribe({
        next: (result) => {
          this.projects = result;
          this.filteredProjects = this.projects;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
          this.showError(JSON.stringify(error.message));
        },
        complete: () => {

          if (localStorage.getItem('lastSelectedProject') != null) {
            
            //const obj = JSON.parse(localStorage.getItem('lastSelectedProject') || '');

            const stored = localStorage.getItem('lastSelectedProject');
            const obj = stored ? JSON.parse(stored) : null;

            console.log("obj",obj)            
            if (obj && this.projects.some(p => p.projectId === obj.projectId)) {
              // Proceed with your logic
              console.log('Project exists. Proceeding...');
              this.defaultItem = obj;
              this.getObjectsForProjects(obj);
            }else{
              this.defaultItem.projectname = 'Select Project ...';
              this.defaultItem.projectId = -1;
              this.projectControl.setValue(null); 
              this.cdr.markForCheck();
              console.log(this.defaultItem);
            }


            //this.selectedproject=obj.projectId;
            // this.projects=obj;         
            // console.log(obj.projectId);
          }
          else {
            this.defaultItem.projectname = 'Select Project ...';
            this.defaultItem.projectId = -1;
            this.cdr.markForCheck();
          }

          //console.log(JSON.stringify(this.projects));

        }
      });
    }

  }

  onTabSelect(event: any) {
    console.log(event);
    this.projectdisabled = true;
    if (event.title === 'Companies') {
      this.projectdisabled = true;
    }
    if (event.title === 'Orders') {
      this.getProjectList();
      this.projectdisabled = false;
    }
    if (event.title === 'Access') {
      this.getProjectList();
      this.projectdisabled = false;
    }
  }
  getObjectsForProjects(event: any) {
    this.portalAdminService.setProject(event);
    localStorage.setItem('lastSelectedProject', JSON.stringify(event));
    this.selectedproject = event;
    this.projectSelected = event;
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }

  onProjectFilter(value: string): void {
    this.filteredProjects = this.projects.filter(p =>
      p.projectname && p.projectname.toLowerCase().includes(value.toLowerCase())
    );
  }
}
